
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apps/dashboard",
      function () {
        return require("private-next-pages/apps/dashboard.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apps/dashboard"])
      });
    }
  